module.exports = __webpack_public_path__ + "img/stick_activites_accrobranche.1893f4a9.svg";